import React, { useEffect } from 'react';
import { Container, Header, Divider } from 'semantic-ui-react';
import AnimatedIllustration from '@src/assets/gifs/manutencao.gif';

const styles = {
  container: { marginTop: '50px', maxWidth: '700px' },
  header: { marginBottom: '20px', fontSize: '2.5em', color: '#2563eb', fontWeight: 'bold' },
  image: { width: '100%', maxWidth: 450, marginBottom: '20px' },
  divider: { border: '1px dashed #f3f4f6' },
  subHeader: { marginBottom: '10px', color: '#0f172a' },
  paragraph: { fontSize: '1.2em', color: '#4b5563', lineHeight: '1.6' },
  boldParagraph: { fontSize: '1.2em', fontWeight: 'bold', color: '#0f172a' },
  footer: { fontSize: '1em', color: '#999', marginTop: '20px' },
  highlight: { color: '#2563eb' }
};

const createConfetti = () => {
  const confettiContainer = document.createElement('div');

  confettiContainer.style.position = 'fixed';
  confettiContainer.style.top = 0;
  confettiContainer.style.left = 0;
  confettiContainer.style.width = '100%';
  confettiContainer.style.height = '100%';
  confettiContainer.style.pointerEvents = 'none';

  document.body.appendChild(confettiContainer);

  for (let i = 0; i < 27; i++) {
    const confetti = document.createElement('div');
    confetti.innerText = '🛠️';
    confetti.style.position = 'absolute';
    confetti.style.fontSize = '24px';
    confetti.style.animation = `fall ${Math.random() * 3 + 2}s linear infinite`;
    confetti.style.left = `${Math.random() * 100}%`;
    confetti.style.top = `${Math.random() * -100}%`;
    confettiContainer.appendChild(confetti);
  }

  const style = document.createElement('style');
  style.innerHTML = `
    @keyframes fall {
      to {
        transform: translateY(100vh);
      }
    }
  `;
  document.head.appendChild(style);
};

const AvisoManutencao = () => {
  useEffect(() => {
    createConfetti();
  }, []);

  return (
    <Container textAlign="center" style={styles.container}>
      <Header as="h1" style={styles.header}>
        Estamos em Manutenção
      </Header>

      <img src={AnimatedIllustration} alt="Aviso de manutenção" style={styles.image} />

      <Divider style={styles.divider} />

      <Header as="h3" style={styles.subHeader}>
        Pedimos desculpas pelo inconveniente.
      </Header>

      <p style={styles.paragraph}>Estamos realizando melhorias para oferecer um serviço ainda melhor.</p>

      <p style={styles.footer}>Agradecemos sua paciência e compreensão.</p>
    </Container>
  );
};

export default AvisoManutencao;
